import { Dialog } from '@origo/origo-ui';
import { parseChangelog } from './parseChangelog';
import styles from './VersionInfo.module.css';

interface ChangelogDialogProps {
    open: boolean;
    onClose: () => void;
    appName: string;
    changelogMarkdown: string;
}

function formatBuildDate(iso: string): string {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return iso;
    return d.toLocaleDateString('nb-NO', { day: '2-digit', month: '2-digit', year: 'numeric' });
}

export function ChangelogDialog({ open, onClose, appName, changelogMarkdown }: ChangelogDialogProps) {
    const entries = parseChangelog(changelogMarkdown);

    return (
        <Dialog open={open} onClose={onClose} title={`Om ${appName}`}>
            <div className={styles.dialogMeta}>
                <div className={styles.versionLine}>
                    <strong>Versjon {__APP_VERSION__}</strong>
                    <span className={styles.commit}>({__APP_COMMIT__})</span>
                </div>
                <div className={styles.buildDate}>Bygget {formatBuildDate(__APP_BUILD_DATE__)}</div>
            </div>

            <h3 className={styles.changelogTitle}>Endringslogg</h3>
            {entries.length === 0 ? (
                <p>Ingen endringer registrert ennå.</p>
            ) : (
                <ol className={styles.entries}>
                    {entries.map(entry => (
                        <li key={entry.version} className={styles.entry}>
                            <header className={styles.entryHeader}>
                                <span className={styles.entryVersion}>{entry.version}</span>
                                <span className={styles.entryDate}>{entry.date}</span>
                            </header>
                            {entry.sections.map(section => (
                                <div key={section.heading} className={styles.section}>
                                    <h4 className={styles.sectionHeading}>{section.heading}</h4>
                                    <ul className={styles.itemList}>
                                        {section.items.map((item, idx) => (
                                            <li key={idx}>{item}</li>
                                        ))}
                                    </ul>
                                </div>
                            ))}
                        </li>
                    ))}
                </ol>
            )}
        </Dialog>
    );
}
